import React, { createContext, useState, useContext, useEffect } from 'react';
import { useUser } from '@clerk/clerk-react'; 
import { useUserContext } from './userSignedInContext';
import { checkUserAuthorizationAndRole } from '../services/userService';

const UserAuthorizationContext = createContext();

export const useUserAuthorization = () => useContext(UserAuthorizationContext);

export const UserRoleAndAuthProvider = ({ children }) => {
  const { user } = useUser(); 
  const { isSignedIn } = useUserContext(); // Access the signed-in status
  const [userAuthData, setUserAuthData] = useState(() => ({
    authorization: localStorage.getItem("authorization") || null,
    role: localStorage.getItem("role") || null,
    loading: true
  }));
  const [error, setError] = useState(null); 

  useEffect(() => {
    const fetchUserAuthData = async () => {
      try {
        setUserAuthData(prevState => ({ ...prevState, loading: true }));

        const { id: clerkId } = user; 
        const data = await checkUserAuthorizationAndRole(clerkId);
      
        const newAuthData = {
          authorization: data.authorization,
          role: data.role,
          loading: false  
        };
        setUserAuthData(newAuthData);

        // Store each property separately in localStorage
        localStorage.setItem("authorization", data.authorization);
        localStorage.setItem("role", data.role);
        setError(null); 
      } catch (err) {
        console.error('Error fetching user data:', err);
        setError('Failed to fetch user authorization/role'); 
        setUserAuthData(prevState => ({ ...prevState, loading: false })); 
      }
    };

    if (isSignedIn && user) {  // Fetch only if signed in and user data is available
      fetchUserAuthData();
    }
  }, [isSignedIn, user]); 

  return (
    <UserAuthorizationContext.Provider value={{ ...userAuthData, error }}>
      {children}
    </UserAuthorizationContext.Provider>
  );
};
